<template>
  <div class="PrintMsg">
    <el-dialog
      title="查看补打说明"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose">
      <el-form style="margin-top: 20px" :model="ruleForm" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <el-form-item label="补打原因" prop="repairPrintReason">
          <el-select v-model="ruleForm.repairPrintReason" placeholder="请选择补打原因">
            <el-option label="错误打印" :value="1"></el-option>
            <el-option label="损坏证书" :value="2"></el-option>
            <el-option label="丢失证书" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请说明" prop="repairPrintExplain">
          <el-input v-model="ruleForm.repairPrintExplain" type="textarea" :rows="3" maxlength="500" size="small" placeholder="请输入申请说明"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-image style="width: 250px;"
                  :src="ruleForm.repairPrintImg"
                  :preview-src-list="[ruleForm.repairPrintImg]"></el-image>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PrintMsg',
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        repairPrintReason: '',
        repairPrintExplain: '',
        repairPrintImg: ''
      }
    }
  },
  methods: {
    init(row) {
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = row[key]
      })
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.PrintMsg {

}
</style>
